import React, { Component } from 'react';
import PageTitle from 'shared_components/page_title';
import SearchPager from 'shared_components/search_pager';
import { GLOBAL_TABLE_PAGE_SIZE } from 'global_config/constant-global';
import { RegexInput } from 'shared_components/pattern_input';
import fetchDonors from 'services/blood_bank/screening'; // this gets the default func fetchPatients from screening.jsx
import Message from 'shared_components/message';

import { Row, Col, Table, Button, Typography, Form, Pagination, Tag } from 'antd';

const { Text } = Typography;
const columns = [
	{
		title: "DONOR'S ID",
		dataIndex: 'donor_id',
		width: 100,
		fixed: 'left',
	},
	{
		title: 'LAST NAME',
		dataIndex: 'last_name',
		width: 150,
		fixed: 'left',
	},
	{
		title: 'FIRST NAME',
		dataIndex: 'first_name',
		width: 150,
	},
	{
		title: 'MIDDLE NAME',
		dataIndex: 'middle_name',
		width: 150,
	},
	{
		title: 'GENDER',
		dataIndex: 'gender',
		width: 80,
	},
	{
		title: 'DATE OF BIRTH',
		dataIndex: 'birth_date',
		width: 120,
	},
	{
		title: 'ADDRESS',
		render: record =>
			`${record.province_name}, ${record.city_name}, ${record.barangay_name}, ${
				record.address_line_1
			}, ${record.address_line_2 === null ? '' : record.address_line_2}`,
		width: 400,
	},
	{
		title: 'BLOOD TYPE',
		dataIndex: 'blood_type_name',
		width: 120,
	},
	{
		title: 'LAST EXTRACTED',
		dataIndex: 'last_extracted_date',
		width: 120,
	},
	{
		title: 'status',
		dataIndex: 'extraction_status',
		width: 150,
		fixed: 'right',
		render: status => (
			<Tag
				color={
					status.toUpperCase() === 'EXPIRED'
						? 'red'
						: status.toUpperCase() === 'INVALID'
						? 'red'
						: 'green'
				}
			>
				{status.toUpperCase()}
			</Tag>
		),
	},
];

export default class ForScreeningSearch extends Component {
	constructor(props) {
		super(props);
		this.state = {
			data: [],
			loading: false,
			pageSize: GLOBAL_TABLE_PAGE_SIZE,
			count: 0,
			response: {},
			page: 1,
		};
		this.formRef = React.createRef();
	}

	redirect = donorDetail => {
		this.props.history.push('/bloodbank/screening/details', { donorDetail: donorDetail });
	};

	handleSubmit = async () => {
		const { pageSize, page } = this.state;
		const { getFieldsValue } = this.formRef.current;
		const { donorID, donorName } = getFieldsValue();

		this.setState({ loading: true });
		const donors = await fetchDonors(donorName, donorID, pageSize, page);
		this.setState({
			showPagination: true,
			loading: false,
			donorName,
			donorID,
			response: donors,
			data: donorID ? donors : donors.results,
			count: donorID ? 1 : donors.count,
		});

		if (donors.length <= 0) Message.info('No results found');
	};

	handleChangeTableSize = async pageSize => {
		const { donorName, page, donorID } = this.state;
		const donors = await fetchDonors(donorName, donorID, pageSize, page);
		this.setState({
			pageSize,
			response: donors,
			count: donorID ? 1 : donors.count,
			data: donorID ? donors : donors.results,
		});
	};

	onPagination = async page => {
		const { donorName, pageSize, donorID } = this.state;
		const donors = await fetchDonors(donorName, donorID, pageSize, page);
		this.setState({
			pageSize,
			response: donors,
			count: donorID ? 1 : donors.count,
			data: donorID ? donors : donors.results,
		});
	};

	hideModal = () => {
		this.setState({
			isDisplayModal: false,
		});
	};

	showModal = () => {
		this.setState({
			isDisplayModal: true,
		});
	};

	onFocusDonorId = () => {
		const { setFieldsValue } = this.formRef.current;
		setFieldsValue({ donorName: '' });
	};

	onFocusDonorName = () => {
		const { setFieldsValue } = this.formRef.current;
		setFieldsValue({ donorID: '' });
	};

	clearInputs = () => {
		const { setFieldsValue } = this.formRef.current;
		this.setState({
			data: [],
			donorID: null,
			donorName: null,
			count: 0,
			showPagination: false,
		});
		setFieldsValue({ donorID: '', donorName: '' });
	};

	render() {
		const { data, pageSize, count, response, showPagination } = this.state;

		return (
			<div>
				<PageTitle pageTitle="SCREENING" />
				<div className="space-y-md"></div>
				<Form
					onFinish={this.handleSubmit}
					className="blood-extract-search-form"
					layout="vertical"
					ref={this.formRef}
				>
					<div className="container">
						<Col className="donor-id">
							<Form.Item label="DONOR'S ID" name="donorID">
								<RegexInput
									regex={/[0-9]/}
									maxLength={100}
									onFocus={this.onFocusDonorId}
									placeholder="Donor's ID"
								/>
							</Form.Item>
						</Col>
						<p className="font-md leading-none text">OR</p>
						<Col className="donor-name">
							<Form.Item label="DONOR'S NAME" name="donorName">
								<RegexInput
									regex={/[A-Za-z0-9, -]/}
									maxLength={100}
									onFocus={this.onFocusDonorName}
									placeholder="Lastname, Firstname"
								/>
							</Form.Item>
						</Col>
						<Col>
							<Form.Item shouldUpdate>
								{({ getFieldsValue }) => {
									const { donorID, donorName } = getFieldsValue();
									const disabled = !(donorID || (donorName && donorName.length > 0));
									return (
										<div className="buttons">
											<Button
												className="form-button"
												shape="round"
												style={{ width: 120 }}
												onClick={this.clearInputs}
											>
												CLEAR
											</Button>
											<Button
												className="form-button"
												shape="round"
												type="primary"
												htmlType="submit"
												style={{ width: 120 }}
												disabled={disabled}
											>
												SEARCH
											</Button>
										</div>
									);
								}}
							</Form.Item>
						</Col>
					</div>
				</Form>
				<SearchPager
					handleChangeSize={this.handleChangeTableSize}
					pageTotal={count}
					pageSize={pageSize}
					response={response}
				/>
				<Table
					className="blood-extract-search-table"
					style={{ textTransform: 'uppercase', marginTop: 10 }}
					dataSource={data}
					pagination={false}
					loading={this.state.loading}
					columns={columns}
					rowKey={record => record.donor_id}
					onRow={record => {
						return {
							onDoubleClick: () => {
								this.redirect(record);
							},
						};
					}}
					scroll={{ x: ' 1500px' }}
				/>
				<div className="space-y-sm"></div>
				{showPagination === true ? (
					<div style={{ display: 'flex' }}>
						<Pagination
							style={{ marginLeft: 'auto' }}
							pageSize={pageSize}
							total={count}
							onChange={this.onPagination}
						/>
					</div>
				) : null}
			</div>
		);
	}
}
